import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import classnames from 'classnames';

/** Use this component when using multiple CardButtons or other actions */ const CardActions = (_param)=> {
    var { children , className  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "children",
        "className"
    ]);
    return React.createElement("div", swcHelpers.extends({
        className: classnames('card-actions', className)
    }, rest), children);
};
var CardActions$1 = CardActions;

export { CardActions$1 as default };
//# sourceMappingURL=CardActions.js.map
